module.exports = __webpack_public_path__ + "static/media/my-claimed-calls.da3d7b7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/my-claimed-calls.svg
// module id = 874
// module chunks = 0